<template>
  <div v-loading="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: '0 0 20px' }" class="sticky-container">
      <template slot="header">
        <el-row :gutter="10" class="filter-container">
          <el-col :xs="24" :sm="6">
            <el-input v-model="queryParams.keyword" class="filter-item" placeholder="供应商名称" clearable />
          </el-col>
          <el-col :xs="24" :sm="3">
            <el-select v-model="queryParams.status" class="filter-item" placeholder="状态" clearable>
              <el-option label="禁用" :value="0" />
              <el-option label="启用" :value="1" />
            </el-select>
          </el-col>
          <el-col :xs="24" :sm="9">
            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            <el-button class="filter-item" style="margin-left: 10px;" type="danger" icon="el-icon-edit" @click="handleCreate">增加供应商</el-button>
          </el-col>
        </el-row>
      </template>

      <el-table v-sticky-header fit highlight-current-row :data="list" header-cell-class-name="table-header-cell style1">
        <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell style1" />
        <el-table-column label="供应商名称" prop="supplierName" min-width="150" />
        <el-table-column label="联系人" prop="contact" width="150" />
        <el-table-column label="联系电话" prop="mobile" width="150" />
        <el-table-column label="发货地址" prop="shippingAddress" min-width="150" />
        <el-table-column label="退货地址" prop="deliveryAddress" min-width="150" />
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.status" class="rectangle md" :active-value="1" :inactive-value="0" @change="handleUpdate(row)" />
          </template>"
        </el-table-column>
        <el-table-column align="center" width="80" fixed="right">
          <template slot-scope="scope">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native.stop="handleEdit(scope.row, scope.$index)"><i class="el-icon-edit" /> 编辑供应商</el-dropdown-item>
                <el-dropdown-item @click.native.stop="handleRemove(scope.row, scope.$index)"><i class="el-icon-delete" /> 删除供应商</el-dropdown-item>
                <el-dropdown-item divided @click.native.stop="handleReset(scope.row, scope.$index)"><i class="el-icon-refresh" /> 重置密码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>

    <el-dialog :title="dialogFormTitle" :visible.sync="dialogFormVisible" :fullscreen="device === 'mobile'">
      <el-form ref="dataForm" :rules="rules" :model="detail" label-width="120px" style="padding-right: 15px;">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="供应商名称" prop="supplierName">
              <el-input v-model="detail.supplierName" placeholder="请输入供应商名称" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :lg="showPassword ? 8 : 12">
            <el-form-item class="inline-form-item" label="联系人" prop="contact">
              <el-input v-model="detail.contact" placeholder="请输入联系人名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="showPassword ? 8 : 12">
            <el-form-item class="inline-form-item" label="联系电话" prop="mobile">
              <el-input v-model="detail.mobile" placeholder="请输入联系电话" maxlength="11" clearable />
            </el-form-item>
          </el-col>
          <el-col v-if="showPassword" :xs="24" :sm="12" :lg="8">
            <el-form-item class="inline-form-item" label="登录密码" prop="password">
              <el-input v-model="detail.password" placeholder="请输入登录密码" show-password />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="发货地址" prop="shippingAddress">
              <el-input v-model="detail.shippingAddress" placeholder="请输入发货地址" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="退货地址" prop="deliveryAddress">
              <el-input v-model="detail.deliveryAddress" placeholder="请输入退货地址" clearable>
                <el-checkbox slot="append" @change="sameAddress">同发货地址</el-checkbox>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :md="12">
            <el-form-item label="营业执照代码" prop="licenceNo">
              <el-input v-model="detail.licenceNo" placeholder="请输入营业执照统一社会信用代码" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="资质编号" prop="qualification">
              <el-input v-model="detail.qualification" placeholder="请输入资质编号" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :md="12">
            <el-form-item label="营业执照" prop="businessLicense">
              <div class="image-uploader">
                <el-upload
                  action="#"
                  accept="image/*"
                  class="avatar-uploader"
                  :show-file-list="false"
                  :on-change="imageChange.bind(null, { key: 'businessLicense' })"
                  :http-request="imageUpload.bind(null, { key: 'businessLicense' })"
                >
                  <template v-if="licenseImage.url">
                    <img :src="licenseImage.url" class="avatar">
                    <div class="el-upload-img-actions">
                      <span class="el-upload-img-preview" @click.stop="imagePreview({ key: 'businessLicense' })">
                        <i class="el-icon-zoom-in" />
                      </span>
                      <span class="el-upload-img-delete" @click.stop="imageBeforeRemove({ key: 'businessLicense' })">
                        <i class="el-icon-delete" />
                      </span>
                    </div>
                  </template>
                  <i v-else class="el-icon-plus avatar-uploader-icon" />
                </el-upload>
              </div>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :md="12">
            <el-form-item label="资质图片" prop="certificatePhoto">
              <div class="image-uploader">
                <el-upload
                  action="#"
                  accept="image/*"
                  class="avatar-uploader"
                  :show-file-list="false"
                  :on-change="imageChange.bind(null, { key: 'certificatePhoto' })"
                  :http-request="imageUpload.bind(null, { key: 'certificatePhoto' })"
                >
                  <template v-if="qualificationImage.url">
                    <img :src="qualificationImage.url" class="avatar">
                    <div class="el-upload-img-actions">
                      <span class="el-upload-img-preview" @click.stop="imagePreview({ key: 'certificatePhoto' })">
                        <i class="el-icon-zoom-in" />
                      </span>
                      <span class="el-upload-img-delete" @click.stop="imageBeforeRemove({ key: 'certificatePhoto' })">
                        <i class="el-icon-delete" />
                      </span>
                    </div>
                  </template>
                  <i v-else class="el-icon-plus avatar-uploader-icon" />
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item class="inline-form-item" label="启用">
              <el-switch v-model="detail.status" :width="60" class="rectangle" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template slot="footer">
        <el-button size="medium" @click="dialogFormVisible = false">取&nbsp;&nbsp;消</el-button>
        <el-button size="medium" type="primary" @click="handleSubmit">提交保存</el-button>
      </template>
    </el-dialog>

    <el-image ref="elImage" style="width: 0; height: 0;" :src="previewImg" :preview-src-list="previewList" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { uploadFile } from '@/api/oss'
import { StickyHeader } from '@cell-x/el-table-sticky'
import { getSupplierPages, saveDetail, removeDetail, resetPassword, updateStatus } from '@/api/supplier'

export default {
  name: 'SupplierList',
  components: {
    Pagination: () => import('@/components/Pagination')
  },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      showPassword: true,
      dialogFormTitle: '',
      dialogFormVisible: false,
      queryParams: {
        keyword: undefined,
        status: undefined,
        page: 1,
        limit: 20
      },
      detail: {},
      editIndex: -1,
      licenseImage: {},
      qualificationImage: {},
      previewImg: undefined,
      previewList: [],
      rules: {
        supplierName: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        contact: [{ required: true, message: '请输入联系人名称', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      getSupplierPages(this.queryParams).then(response => {
        // console.log(response)
        this.total = response.total
        this.list = [...response.records]
      }).finally(() => this.$util.delay(500).then(() => { this.loading = false }))
    },
    resetDetail() {
      this.detail = Object.assign({}, {
        id: undefined,
        supplierName: undefined,
        contact: undefined,
        mobile: undefined,
        password: undefined,
        status: 1,
        shippingAddress: undefined,
        deliveryAddress: undefined,
        licenceNo: undefined,
        businessLicense: undefined,
        qualification: undefined,
        certificatePhoto: undefined
      })
      this.licenseImage = { url: undefined, file: undefined }
      this.qualificationImage = { url: undefined, file: undefined }
    },
    handleFilter() {
      this.queryParams.page = 1
      this.fetchData()
    },
    handleCreate() {
      // this.dialogFormVisible = true
      // this.$nextTick(() => {
      //   this.dialogFormTitle = '新增供应商'
      //   this.showPassword = true
      //   this.editIndex = -1
      //   this.resetDetail()
      // })
      this.$router.push({ path: `/supplier/detail`, query: { action: 'create' }})
    },
    handleEdit(item, index) {
      // this.dialogFormVisible = true
      // this.$nextTick(() => {
      //   this.qualificationImage = { url: item.certificatePhoto, file: undefined }
      //   this.licenseImage = { url: item.businessLicense, file: undefined }

      //   this.dialogFormTitle = '编辑供应商'
      //   this.detail.password = undefined
      //   this.showPassword = false
      //   this.editIndex = index
      //   this.detail = item
      // })
      this.$router.push({ path: `/supplier/detail`, query: { action: 'edit', id: `${item.id}` }})
    },
    sameAddress(checkStatus) {
      if (checkStatus) this.detail.deliveryAddress = this.detail.shippingAddress
    },
    imageChange(obj, file) {
      if (!file) return false

      const isImage = `${file.raw.type}`.startsWith('image/')
      if (!isImage) return this.$message.warning('上传的文件必须是图片')

      if (obj.key === 'businessLicense') {
        this.licenseImage.url = URL.createObjectURL(file.raw)
      } else {
        this.qualificationImage.url = URL.createObjectURL(file.raw)
      }
    },
    imageUpload(obj, form) {
      const formData = new FormData()
      formData.append('file', form.file)
      formData.append('name', form.file.name)
      formData.append('fileSize', form.file.size)
      formData.append('fileType', form.file.type)

      if (obj.key === 'businessLicense') {
        this.licenseImage.file = formData
      } else {
        this.qualificationImage.file = formData
      }
    },
    imagePreview(obj, file) {
      const imageUrl = obj.key === 'businessLicense' ? this.licenseImage.url : this.qualificationImage.url

      this.previewImg = imageUrl
      this.previewList = [imageUrl]
      this.$nextTick(() => this.$refs.elImage.clickHandler())
    },
    imageBeforeRemove(obj, file) {
      this.$confirm('确定删除该图片？', '温馨提示', { type: 'warning' }).then(() => {
        if (obj.key === 'businessLicense') {
          this.licenseImage = Object.assign({}, { url: undefined, file: undefined })
        } else {
          this.qualificationImage = Object.assign({}, { url: undefined, file: undefined })
        }
      }).catch(() => {})
    },
    handleRemove(item, index) {
      this.loading = true
      removeDetail(item).then(response => {
        this.list = response
      }).finally(() => {
        this.$util.delay(500).then(() => { this.loading = false })
      })
    },
    uploadImage() {
      return new Promise((resolve, reject) => {
        const uploadPromises = []
        if (this.licenseImage.file) uploadPromises.push(uploadFile(this.licenseImage.file))
        if (this.qualificationImage.file) uploadPromises.push(uploadFile(this.qualificationImage.file))
        if (uploadPromises.length) {
          Promise.all(uploadPromises).then(response => {
            if (this.licenseImage.file) this.licenseImage = Object.assign({}, { url: response[0], file: undefined })
            if (this.qualificationImage.file) this.qualificationImage = Object.assign({}, { url: response[response.length - 1], file: undefined })

            resolve()
          }).catch(() => reject('图片上传失败'))
        } else {
          resolve()
        }
      })
    },
    handleSubmit() {
      this.loading = true
      this.uploadImage().then(() => {
        this.detail = Object.assign({}, this.detail, {
          businessLicense: this.licenseImage.url,
          certificatePhoto: this.qualificationImage.url
        })
        return saveDetail(this.detail)
      }).then(response => {
        if (this.editIndex >= 0) this.list.splice(this.editIndex, 1, response)

        this.$util.delay(500).then(() => {
          this.editIndex = -1
          this.loading = false
          this.dialogFormVisible = false
        })
      }).catch(() => { this.loading = false })
    },
    handleUpdate(item) {
      updateStatus(item).then(response => {
        if (!response) item.status = !item.status
      }).catch(() => {})
    },
    handleReset(item, index) {
      this.$confirm('您确认要重置该供应商的登录密码吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetPassword(item).then(response => {
          this.$message.success(response)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card__header {
    padding-bottom: 0;
  }
}
.max-width-input {
  width: 150px;
  max-width: 100%;
}
</style>
